import { PortalUpload } from "@/features/portal/components/documents/portal-upload";

/** `/portal/documents/upload` — stage + send documents to the firm. */
export default function UploadPage() {
  return <PortalUpload />;
}
